import React, { useEffect, useState } from "react"
import qs from "query-string"
import _ from "lodash"
import styled from "styled-components"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useUpdateInboxHeader } from "../../hooks/useUpdateInboxHeader"
import TextField from "../../components/Radiate/TextField/TextField"
import theme from "../../stylesheets/theme"
import { ModalBody } from "../../components/Radiate/ThemedModal/ThemedModal"
import NewBoxButton from "../../components/Radiate/NewBoxButton/NewBoxButton"

import { useMutate } from "../../hooks/useMutate"
import { changeInboxFolder, closeInboxModal, sendToastMessageToInbox } from "../../components/util"

const INBOX_URL = process.env.REACT_APP_INBOX_URL
const SERVER_API_PATH_GROUP = process.env.REACT_APP_SERVER_GROUP_API_PATH

const SPACING = "8px"
const LARGE_SPACING = "16px"
const AVATAR_SIZE = "60px"
const PHONE_INPUT_WIDTH = "60%"
const COUNTRY_CODE_WIDTH = "40%"

const DANGER_TEXT = "#ef4444"

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.gray02};
`

const AvatarSection = styled.div`
  flex: 0 0 ${AVATAR_SIZE};
  cursor: not-allowed;
`

const GroupDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

const AvatarPlaceholder = styled.div`
  width: ${AVATAR_SIZE};
  height: ${AVATAR_SIZE};
  border-radius: 50%;
  background-color: ${theme.gray2};
  display: flex;
  align-items: center;
  justify-content: center;
`

const IconWrapper = styled.div`
  color: white;
  font-size: 24px;
`

const GroupInfoWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: ${SPACING};
  border-radius: ${SPACING};
  gap: ${SPACING};
`

const MarginWrapper = styled.div`
  margin: ${SPACING};
`

export const ActionBar = styled.div`
  box-sizing: border-box;
  border-top: 1px solid ${theme.gray1};
  padding: 8px 12px;
  display: flex;
  justify-content: ${(props) => (props.hasError ? "space-between" : "flex-end")};
  align-items: center;
  justify-self: flex-end;

  .box-button-container {
    margin-left: 8px;
  }
`

const InlineEligibilityError = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${DANGER_TEXT};
  font-size: 13px;
  font-weight: 500;
  flex: 0 0 auto;
  margin-right: auto;
`

export const PhoneFieldGroup = styled.div`
  display: flex;
  gap: ${SPACING};
  align-items: flex-start;
`

export const CountryCodeWrapper = styled.div`
  width: ${COUNTRY_CODE_WIDTH};
`

export const PhoneWrapper = styled.div`
  width: ${PHONE_INPUT_WIDTH};
`

const CheckboxLabel = styled.span`
  font-size: 12px;
`

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const StyledCheckbox = styled.input`
  width: 16px;
  height: 16px;
  border-radius: 3px;
  cursor: pointer;
  accent-color: ${theme.primary};
`

// eslint-disable-next-line no-unused-vars
const CreateGroup = ({ location }) => {
  const query = qs.parse(location.search)
  console.log({ query })

  const channelId = query.channel
  const [signedContext, setSignedContext] = useState(query.signedContext || null)
  const [contextToken, setContextToken] = useState(query.contextToken || null)

  // Parse the payload if it's a JSON string
  const parsePayload = (payloadStr) => {
    if (!payloadStr) return null
    try {
      return typeof payloadStr === "string" ? JSON.parse(payloadStr) : payloadStr
    } catch (error) {
      console.error("Error parsing payload:", error)
      return payloadStr
    }
  }

  const [payload, setPayload] = useState(parsePayload(query.payload))
  const [subject, setSubject] = useState("")
  const [description, setDescription] = useState("")
  const [approvalRequired, setApprovalRequired] = useState(false)
  const [errors, setErrors] = useState({})
  const [eligibility, setEligibility] = useState(null)
  const [eligibilityChecked, setEligibilityChecked] = useState(false)

  console.log({ payload }, "Create group Payload")
  console.log({ contextToken, SERVER_API_PATH_GROUP }, "Create group debug")

  // Fetch eligibility directly using fetch API for GET request
  useEffect(() => {
    if (contextToken && !eligibilityChecked) {
      const checkEligibilityAPI = async () => {
        try {
          const headers = {
            "Content-Type": "application/json",
            "X-Woztell-Context": contextToken,
          }

          const response = await fetch(`${SERVER_API_PATH_GROUP}/group/eligibility`, {
            method: "GET",
            headers,
          })

          const data = await response.json()
          setEligibilityChecked(true)
          if (data.ok === 1) {
            setEligibility({
              eligible: data.eligible,
              reason: data.reason,
            })
            if (!data.eligible && data.reason) {
              sendToastMessageToInbox({
                message: data.reason,
                type: "warning",
                options: {
                  duration: 8000,
                },
              })
            }
          }
        } catch (error) {
          setEligibilityChecked(true)
          sendToastMessageToInbox({
            message: `Failed to check eligibility: ${error.message}`,
            type: "error",
            options: {
              duration: 5000,
            },
          })
        }
      }

      checkEligibilityAPI()
    }
  }, [contextToken, eligibilityChecked, SERVER_API_PATH_GROUP])

  const createGroup = useMutate({
    url: `${SERVER_API_PATH_GROUP}/api/group`,
    contextToken,
    approvalRequired,
    method: "PUT",
    onSuccess: () => {
      sendToastMessageToInbox({
        message: "Group created successfully, please wait for the group to be created inside inbox and refresh the page",
        type: "success",
        options: {
          duration: 15000,
        },
      })
      closeInboxModal()
      changeInboxFolder({
        folderId: "main",
      })
    },
    onFailure: (errorMessage) => {
      let displayMessage = errorMessage
      console.log({ displayMessage })

      // Handle specific error case for permission denied
      if (errorMessage && errorMessage.includes("Application does not have permission for this action")) {
        displayMessage = "Group creation failed. You don't have permission to perform this action.\nPlease contact your administrator."
      }

      sendToastMessageToInbox({
        message: displayMessage,
        type: "error",
        options: {
          duration: 10000,
        },
      })
    },
  })

  const receiveMessage = (event) => {
    const whitelistedOrigins = INBOX_URL.split("||")
    if (!whitelistedOrigins.includes(event.origin)) {
      return
    }
    if (event?.data) {
      if (!_.isEmpty(event.data?.payload)) {
        setPayload(event.data?.payload)
        setSignedContext(event.data?.signedContext)
      }
    }
  }

  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      window.addEventListener("message", receiveMessage, false)
      window.parent.postMessage("iframeFinishLoading", "*")
    }
    return () => {
      window.removeEventListener("message", receiveMessage, false)
    }
  }, [])

  // Initialize payload and signedContext from URL if not already set
  useEffect(() => {
    if (!payload && query.payload) {
      const parsedPayload = parsePayload(query.payload)
      setPayload(parsedPayload)
    }
    if (!signedContext && query.signedContext) {
      setSignedContext(query.signedContext)
    }

    if (!contextToken && query.ctx) {
      setContextToken(query.ctx)
    }
  }, [query.payload, query.signedContext, payload, signedContext, contextToken, query.contextToken])

  useUpdateInboxHeader({ title: "Create a group", isGroupsView: true })

  const handleSubmit = () => {
    const newErrors = {}
    let hasErrors = false

    if (!subject.trim()) {
      newErrors.subject = "Group subject is required"
      hasErrors = true
    }

    setErrors(newErrors)

    if (hasErrors) {
      sendToastMessageToInbox({
        message: "Group name is required",
        type: "error",
        options: {
          duration: 5000,
        },
      })
      return
    }

    createGroup.mutate({
      channelId,
      subject,
      description,
      contextToken,
    //   payload, --- IGNORE ---
    //   signedContext, --- IGNORE ---
    })
  }

  return (
    <FormContainer>
      <ModalBody style={{
        padding: 0,
        display: "flex",
        flexDirection: "column",
        gap: LARGE_SPACING,
        overflow: "visible",
        flex: 1,
        overflowY: "visible",
      }}
      >
        <MarginWrapper>
          <GroupInfoWrapper>
            <AvatarSection>
              <AvatarPlaceholder>
                <IconWrapper>
                  <FontAwesomeIcon size="lg" icon={faUser} />
                </IconWrapper>
              </AvatarPlaceholder>
            </AvatarSection>
            <GroupDetailsSection>
              <div>
                <TextField
                  placeholder="Group name"
                  useInput
                  noBorderStyle
                  value={subject}
                  onChange={(e) => {
                    setSubject(e.target.value)
                    if (errors.subject) {
                      setErrors((prev) => ({ ...prev, subject: null }))
                    }
                  }}
                  error={!!errors.subject}
                  style={{
                    borderColor: errors.subject ? DANGER_TEXT : undefined,
                  }}
                />
              </div>
              <TextField
                placeholder="Group description (optional)"
                useInput
                minRows={3}
                noBorderStyle
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
              <div style={{ marginTop: "12px" }}>
                <CheckboxWrapper>
                  <StyledCheckbox
                    type="checkbox"
                    checked={approvalRequired}
                    onChange={(e) => setApprovalRequired(e.target.checked)}
                  />
                  <CheckboxLabel>Require approval to join group</CheckboxLabel>
                </CheckboxWrapper>
              </div>
            </GroupDetailsSection>
          </GroupInfoWrapper>
        </MarginWrapper>

      </ModalBody>
      <ActionBar hasError={eligibilityChecked && eligibility && !eligibility.eligible}>
        {eligibilityChecked && eligibility && !eligibility.eligible && (
          <InlineEligibilityError>
            You are not eligible to create a group
          </InlineEligibilityError>
        )}
        <NewBoxButton
          style={{
            position: "relative",
            top: "-3px",
            minWidth: "fit-content",
          }}
          text="Create Group"
          icon="plus"
          primary
          loading={createGroup.loading}
          disabled={!eligibilityChecked || (eligibility && !eligibility.eligible)}
          onClick={handleSubmit}
        />
      </ActionBar>
    </FormContainer>
  )
}
export default CreateGroup
